import { YardOutlined } from "@mui/icons-material";
import { QRCode } from "antd";
import PropTypes from "prop-types";
import MDBox from "~/components/MDBox";
import MDTypography from "~/components/MDTypography";

const BarCodeComponent = (props) => {
  const { item } = props;
  return (
    <MDBox
      display="flex"
      flexDirection="column"
      justifyContent="center"
      alignItems="center"
    >
      <QRCode
        value={`${import.meta.env.VITE_APP_CLIENT_URL}/#/plant/${
          item.BarCode_Number
        }`}
        icon={<YardOutlined />}
      />
      {/* <Icon fontSize="default">{icon}</Icon> */}
      <MDBox pb={1} mt={1} px={2} textAlign="center" lineHeight={1.25}>
        <MDTypography
          variant="h6"
          fontWeight="medium"
          textTransform="capitalize"
        >
          {item.BarCode_Serial_No}
        </MDTypography>
        {/* {description && (
                              <MDTypography
                                variant="caption"
                                color="text"
                                fontWeight="regular"
                              >
                                {item.BarCode_Serial_No}
                              </MDTypography>
                            )} */}
        {/*
                              {description && !value ? null : <Divider />}
                              {value && (
                                <MDTypography variant="h6" fontWeight="medium">
                                  {value}
                                </MDTypography>
                              )} */}
      </MDBox>
    </MDBox>
  );
};

BarCodeComponent.propTypes = {
  item: PropTypes.shape({
    BarCode_Number: PropTypes.string.isRequired, // Adjust the type as needed
    BarCode_Serial_No: PropTypes.string.isRequired,
    // Add other properties if needed
  }).isRequired,
};
export default BarCodeComponent;
